import { useTranslation } from '@framework/i18n';
import { down } from 'styled-breakpoints';
import styled from 'styled-components';
const image = {
  url: require('../../images/MiC_nextgenerationeu_WHITE_Outline.svg'),
};

const LogoImg = styled.img`
  max-width: 100%;
  max-height: 100%;
  border: none;
  margin: 0;
  padding: 0;
  width: 100%;
  height: auto;
`;

const LogoNextgenerationeuWrapper = styled.div`
  max-width: 100%;
  height: auto;
  width: 110px;
  ${down('sm')} {
    width: 90px;
  }
`;
export interface IFrontFooterNextgenerationeuLogoProps {}

/**
 * Logo Nextgenerationeu del footer dell'applicativo.
 */
export function FrontFooterNextgenerationeuLogo(
  props: IFrontFooterNextgenerationeuLogoProps,
) {
  const { t } = useTranslation();
  return (
    <LogoNextgenerationeuWrapper>
      <LogoImg
        src={image.url}
        alt={t(
          'mic.logo-nextgenerationeu.alt',
          "Logo Finanziato dall'unione Europea - NextGenerationEU",
        )}
      />
    </LogoNextgenerationeuWrapper>
  );
}
